
import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { LoggerService } from "@teammood/shared/util/logger";
import { Team } from "@teammood/team";
import { ExportsService } from "../../../exports/exports.service";


@Component({
    selector: 'team-members-export-dialog',
    templateUrl: './team-members-export-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    MatDialogModule
]
})
export class TeamMembersExportDialogComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {team: Team},
        public dialogRef: MatDialogRef<TeamMembersExportDialogComponent, Team>,
        private exportsService: ExportsService,
        private snackBarService: SnackBarService,
        private logger: LoggerService
    ) { }

    async exportTeamMembers() {
        try {
            const teamId = this.data.team.id;
            const result = await this.exportsService.export(teamId, 'userlist', 'excel')
            if (result.message) {
                this.snackBarService.success(result.message);
            }
        } catch (error) {
            this.logger.error("Exports error", error);
            this.snackBarService.error(error.data.error);
        }
    }

    close() {
        this.dialogRef.close();
    }
}